/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const DEFAULT_SITE_TITLE = 'Sirius Experience';
export const DEFAULT_SITE_FAV_ICON = '/favicon.ico';
export const DEFAULT_RESOURCE_URL = '/assets/dell_rectangle_logo.svg';
export const DEFAULT_MOBILE_RESOURCE_URL = '/assets/dell_round_logo.svg';